import React, { useState } from "react";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { currentWeek } from "@/lib/week";
import AfspraakDialog from "@/components/AfspraakDialog";

// v19 A3: vanuit een bezoek een afspraak neerleggen (bijv. bij de TD), met de locatie al ingevuld.
export const BezoekAfspraakKnop = ({ locatie }) => {
  const [open, setOpen] = useState(false);
  const [meta, setMeta] = useState(null);
  const openen = () => {
    api.get("/meta").then((r) => { setMeta(r.data); setOpen(true); }).catch(() => setOpen(true));
  };
  return (
    <>
      <button type="button" data-testid="bezoek-afspraak-knop" onClick={openen}
        className="min-h-[44px] inline-flex items-center gap-1.5 px-3 rounded-md border border-zinc-300 bg-white text-sm font-semibold text-zinc-800 hover:bg-zinc-50 transition-colors">
        <Plus className="h-4 w-4" /> Afspraak
      </button>
      {open && (
        <AfspraakDialog open={open} onOpenChange={setOpen} week={currentWeek()} locaties={meta?.locations || [locatie]} generalBuckets={meta?.generalBuckets || []}
          oms={meta?.oms || []} internKandidaten={meta?.internKandidaten || []} blContact={meta?.blContact || {}}
          afdelingen={meta?.afdelingen || []} defaultLocatie={locatie} onCreated={() => setOpen(false)} />
      )}
    </>
  );
};
